import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_ERROR_MESSAGE_SERVLET_PENDING,
  GET_ERROR_MESSAGE_SERVLET_FAILED,
  GET_ERROR_MESSAGE_SERVLET_FULFILLED,
} from "constants-lib/actionTypes"
import {
  EXCEPTION_MESSAGE_TYPE_BULK,
  EXCEPTION_MESSAGE_TYPE_CONTAINER,
  EXCEPTION_MESSAGE_TYPE_MOVERS,
  EXCEPTION_MESSAGE_TYPE_RESI,
} from "constants-lib/exceptionMessageTypesForServlet"

export const pendingAC = () => ({
  type: GET_ERROR_MESSAGE_SERVLET_PENDING,
})

export const failedAC = (data) => ({
  type: GET_ERROR_MESSAGE_SERVLET_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_ERROR_MESSAGE_SERVLET_FULFILLED,
  payload: data,
})

export const getServletErrorMessagesByServiceType =
  (language, serviceType) => (dispatch, getState) => {
    const { siteLanguage } = getState()
    const locale = encodeURI(language || siteLanguage.language || ``)
    let api = ``
    switch (serviceType) {
      case EXCEPTION_MESSAGE_TYPE_RESI:
        api = `RESI_EXEPTION_MESSAGE_SERVLET`
        break
      case EXCEPTION_MESSAGE_TYPE_BULK:
        api = `BULK_EXCEPTION_MESSGAGE_SERVLET`
        break
      case EXCEPTION_MESSAGE_TYPE_CONTAINER:
        api = `CONTAINER_EXCEPTION_MESSAGE_SERVLET`
        break
      case EXCEPTION_MESSAGE_TYPE_MOVERS:
        api = `MOVERS_EXCEPTION_MESSAGE_SERVLET`
        break
      default:
        break
    }

    const template = URITemplate(urls.url[api])
    const exceptionURL = template.expand({
      locale,
      serviceType,
    })
    const url = exceptionURL
    const config = {
      url,
      method: `get`,
    }

    dispatch(pendingAC(locale))
    // eslint-disable-next-line consistent-return
    return axios(config)
      .then((response) => {
        const formattedResponse =
          response?.data?.data?.resiAddressBarExceptionList?.items ||
          response?.data?.data?.bulkAddressBarExceptionList?.items ||
          response?.data?.data?.containerIssueAddressBarExceptionList?.items
        dispatch(fulfilledAC(formattedResponse))
        return response.data
      })
      .catch((error) => {
        dispatch(failedAC(error?.response?.status))
        return error
      })
  }
